import Link from 'next/link';
import {RiDeleteBin6Line} from 'react-icons/ri';
import { HiOutlinePlus, HiMinus} from 'react-icons/hi';
import axios from 'axios';
import {useRouter} from "next/router";
import {useToasts} from "react-toast-notifications";
import CarritoDiscount from './carrito-discount';
import CartResume from "./cart-resume";
import Complement from './complement';

const Carrito = ({data, coupon})=>{
    const router = useRouter();
    const { addToast } = useToasts();
    const getItems = ()=>{
      return data.products.map(i=>{
         return <div className="cartItem" key={i.id_producto}>
             <div className="cartItemColumn">
                 <Link href={`/producto/${i.uri}`}>
                     <a>
                         <img src={i.fotos[0]} alt={i.nombre}/>
                     </a>
                 </Link>
             </div>
             <div className="cartItemColumn">
                 <p className="cartItemTitle">{i.nombre}</p>
                 <p className="cartItemPrice">${i.precio}.00</p>
                 <span className="cartItemDelete" onClick={ e=>{ deleteProduct(i.id_producto) }}>
                     <RiDeleteBin6Line/>
                 </span>
                 <div className="cartItemChangeContainer">
                     <ul className="cartItemChange">
                         <li className="cartItemChangeHover" onClick={e=>{ updateProduct(i.id_producto,'remove')}}>
                             <HiMinus/>
                         </li>
                         <li className="cartItemChangeNumber">
                             <span>{i.quantity}</span>
                         </li>
                         <li className="cartItemChangeHover" onClick={e=>{ updateProduct(i.id_producto,'add')}}>
                             <HiOutlinePlus/>
                         </li>
                     </ul>
                 </div>
             </div>
         </div>
      });
    };

    const isComplementShow = ()=>{
        if(data?.deliver?.freeshipping > 0 && !data.summary.vip && (data.summary.subtotal < data.deliver.freeshipping)){
            const rest = data.deliver.freeshipping - data.summary.subtotal;
            return <div className="dycComplementSimple">
                <div className="dycComplementSimpleContainer">
                    <h3 className="dycComplementSimpleTitle">OBTÉN TU ENVÍO GRATIS</h3>
                    <p className="dycComplementSimpleDescription">Agrega <b>${rest}</b> en productos y no pagues envio, complementa con chocolates o un globo.</p>
                </div>
                <Complement Type="cart" />
            </div>
        }else{
            return <div className="dycComplementSimple">
                <div className="dycComplementSimpleContainer">
                    <h3 className="dycComplementSimpleTitle">COMPLEMENTA TU COMPRA</h3>
                </div>
                <Complement Type="cart" />
            </div>
        }
    };

    const updateProduct = (product,type)=>{
        axios({
            method: 'POST',
            url: '/api/update-cart',
            data: {
                product,
                type
            }
        })
            .then(d=>{
                router.push('/compra');
            })
            .catch(e=>{
                const msj = (e?.response?.data?.message) ? e.response.data.message : 'No se pudo descontar el producto, recarga la pagina e intenta de nuevo';
                addToast(msj, { appearance: 'warning', autoDismiss: true });
            })
    };

    const deleteProduct = product=>{
        axios({
            method: 'post',
            url: '/api/remove-cart',
            data: {
                product
            }
        })
            .then(d=>{
                router.push('/compra');
            })
            .catch(e=>{
                //console.log('error')
            })
    };
    return <div className="cart">
        <h1 className="title">Tu carrito</h1>
        <div className="container cartContainer marginBottom">
            <div className="cartColumn marginBottom-big">
                {getItems()}
                <br/>
                {isComplementShow()}
            </div>
            <section className="cartColumn">
                <CartResume
                    subtotal={data.summary.subtotal}
                    coupon={data.summary.coupon}
                    municipio={data.deliver.municipio}
                    shipping={data.summary.shipping}
                    total={data.summary.total}
                    isfreeshipping={data.deliver.isfreeshipping}
                    vip={data.summary.vip}
                />
                <CarritoDiscount coupon={coupon} subtotal={data.summary.subtotal}/>
                {(data?.status?.iswrong)
                    ?
                        <>
                            <button className="button button-large marginBottom" disabled={data?.status?.iswrong}>Finalizar compra</button>
                            <span className="cartTooltip">{data.status.message}</span>
                        </>
                    :
                    <Link href="/compra/envio">
                        <a className="button button-large marginBottom" disabled={data?.status?.iswrong}>Finalizar compra</a>
                    </Link>
                }
            </section>
        </div>
    </div>
};

export default Carrito;
